import { apiRoute, API_V1 } from '../helpers/api-route'
import { fetchWrapper } from '../helpers/fetch-wrapper'

export const staffSubmissionService = {
  get,
  getByIdentifiers,
  getAll,
  getCount,
  getCovid,
  getPneumonia,
  getTuberculosis,
  getGeneral,
  getByDateRange,
  getGeneralForPatient,
  getForSet,
  getForPatient,
  update,
  feedback,
  saveAudit,
  toggleFavourite
}

const API_BASE = apiRoute() + API_V1

function get (id, project) {
  return fetchWrapper.get(`${API_BASE}/staff/none/${id}`, { Project: project })
}

function getForPatient (id, project) {
  return fetchWrapper.get(`${API_BASE}/staff/none/list/patient/${id}`, { Project: project })
}

function getByIdentifiers (params, project) {
  return fetchWrapper.get(
    `${API_BASE}/staff/submissions/${params.patient}/${params.study ? params.study : null}`,
    { Project: project }
  )
}

function getAll (filter) {
  return fetchWrapper.get(`${API_BASE}/staff/submissions/${filter}`)
}

function getCount (project) {
  return fetchWrapper.get(`${API_BASE}/staff/none/count`, { Project: project })
}

function getCovid (period, project) {
  return fetchWrapper.get(`${API_BASE}/staff/covid/list/${period}`, { Project: project })
}

function getPneumonia (period, page, project) {
  return fetchWrapper.get(`${API_BASE}/staff/pneumonia/list/${period}/${page}`, { Project: project })
}

function getTuberculosis (period, page, project) {
  return fetchWrapper.get(`${API_BASE}/staff/tb/list/${period}/${page}`, { Project: project })
}

// @deprecated — use getByDateRange instead. No remaining dispatches.
function getGeneral (period, page, project) {
  return fetchWrapper.get(`${API_BASE}/staff/none/list/${period}/${page}`, { Project: project })
}

// Unified date-range list endpoint. Returns { from, to, page, pageSize, total, totalPages, hasMore, records }.
function getByDateRange (project, { from = null, to = null, page = 1, pageSize = 50, sort = 'desc', subgroup = null } = {}) {
  const params = new URLSearchParams()
  if (from) params.set('from', from)
  if (to) params.set('to', to)
  params.set('page', page)
  params.set('pageSize', pageSize)
  params.set('sort', sort)
  if (subgroup) params.set('subgroup', subgroup)
  return fetchWrapper.get(`${API_BASE}/staff/none/list?${params}`, { Project: project })
}

function getGeneralForPatient (id, project) {
  return fetchWrapper.get(`${API_BASE}/staff/none/list/patient/${id}`, { Project: project })
}

function getForSet (id, project) {
  return fetchWrapper.get(`${API_BASE}/staff/none/list/image-set/${id}`, { Project: project })
}

function update (id, labels, tags) {
  return fetchWrapper.post(
    `${API_BASE}/submissions/callback/update/${id}`,
    {
      labels: labels,
      tags: tags
    }
  )
}

function feedback (id, pathologies, other, diagnosis) {
  return fetchWrapper.post(
    `${API_BASE}/submissions/feedback/update/${id}`,
    {
      pathologies: pathologies,
      other: other,
      diagnosis: diagnosis
    }
  )
}

function saveAudit (id, action, description) {
  return fetchWrapper.post(
    `${API_BASE}/submissions/audit/${id}/${action}`,
    { description }
  )
}

function toggleFavourite (id) {
  return fetchWrapper.put(`${API_BASE}/submissions/favourite/${id}`, {})
}
